import React from "react";
import "./card.css";
import Loader from "react-loader-spinner";
import { Formik, Form } from "formik";
// import { CardFundingTextInput } from "../../../../Formik/FormLib";
import * as Yup from "yup";

import {
  ButtonGroup,
  colors,
  // StyledTextInputBankTransfer,
  StyledBankTransferFormButton,
} from "../../../../../Syles/styles.js";
import { BankTranferDetailsTextInput } from "../../../../Formik/BankDetailsInput";
import { Util } from "../../../../../../helpers/util";
import { toast } from "react-toastify";
import { $api } from "../../../../../../helpers/$api";

const CardFunding = ({ setStage, data: [data] }) => {
  const { currency } = Util.getCurrency();
  const changeStage = (value) => {
    setStage(7, value);
  };
  const fundDollar = data && data.selected === "dollar";
  const handleDollarFund = async (amount) => {
    try {
      const { link } = await $api.user.dollarDepositCard(amount);

      window.location = link;
    } catch (error) {
      toast.error(`error initiating ${error.message}`);
    }
  };

  return (
    <div className="card-funding">
      <div className="card-funding-header">
        <h5> By Card</h5>
        <p>Fund your OVest wallet by using your card details</p>
      </div>
      <div className="card-funding-body">
        <p>How much would you like to add to your wallet? </p>
      </div>
      <Formik
        initialValues={{
          amount: "",
        }}
        onSubmit={(values, { setSubmitting, setFieldError }) => {
          if (fundDollar) {
            handleDollarFund(values.amount);
            return;
          }
          changeStage(values.amount);
        }}
        validationSchema={Yup.object({
          amount: Yup.string().required("Amount deposited Field is Required"),
        })}
      >
        {({ isSubmitting }) => (
          <Form>
            <BankTranferDetailsTextInput
              name="amount"
              type="tel"
              placeholder={currency}
            />

            <ButtonGroup>
              {!isSubmitting && (
                <StyledBankTransferFormButton
                  type="submit"
                  style={{ marginTop: "136px" }}
                >
                  Next
                </StyledBankTransferFormButton>
              )}

              {isSubmitting && (
                <Loader
                  type="ThreeDots"
                  color={colors.primary}
                  height={49}
                  width={100}
                />
              )}
            </ButtonGroup>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default CardFunding;
